export default {
  title: 'Maksu',
  description: 'Kaikki maksutapahtumat ovat turvallisia ja salattuja',
  show_more_payment_methods: 'Näytä lisää maksutapoja',
  express_checkout_divider: 'tai',
};
